var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenIssue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 7px;\r\n      }\r\n\r\n      .st0, .st1 {\r\n        stroke: #fff;\r\n      }\r\n\r\n      .st0, .st1, .st2 {\r\n        fill: none;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .st1, .st2 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .st2 {\r\n        stroke: #dc1e37;\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .st4 {\r\n        fill: #dc1e37;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 28.5,
    y: 16.14,
    width: 60.91,
    height: 79.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 40.64,
    y: 25.81,
    width: 7.6,
    height: 7.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 57.43,
    y: 28.21,
    width: 19.69,
    height: 3.53
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 40.64,
    y: 42.94,
    width: 7.6,
    height: 7.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 57.43,
    y: 45.34,
    width: 19.69,
    height: 3.53
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 40.64,
    y: 60.07,
    width: 7.6,
    height: 7.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 57.43,
    y: 62.48,
    width: 19.69,
    height: 3.53
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 40.64,
    y: 77.21,
    width: 7.6,
    height: 7.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 57.43,
    y: 79.61,
    width: 19.69,
    height: 3.53
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "78.25 71.79 58 106.86 98.5 106.86 78.25 71.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "78.25 71.79 58 106.86 98.5 106.86 78.25 71.79"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 77.98,
    cy: 100.44,
    r: 2.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 78.25,
    y1: 80.99,
    x2: 78.25,
    y2: 93.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIssue);
export default __webpack_public_path__ + "static/media/Open Issue.e63da1f9023776454481ced44beb8a87.svg";
export { ForwardRef as ReactComponent };